// utils/StatusColor.js

const statusColorScheme = {
  "Pending": "yellow",
  "In Transit": "blue", 
  "Delivered": "green",
  "Collected": "green",
  "Canceled": "red",
  "Awaiting Pick Up": "purple",
  "Picked Up": "teal"
};
  

  const getStatusColor = (status) => {
    return statusColorScheme[status] || "gray";
  };
  
  export default getStatusColor;
  